import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { isEmail } from 'validator';
import { isValidPhone } from '../../features/auth/utils/phone_validation';
import { removeZeroWidthChars } from '../../utils/string/string.utils';
export const validateFormFieldOnBlur = (fieldName, value) => {
    switch (fieldName) {
        case 'name': {
            const pattern = /^[0-9]|[\u0007\u0008\u0009\u000A\u000B\u000C\u000D]/;
            if (!value) {
                return 'Name is required';
            }
            if (value.length > 100) {
                return 'Maximum 100 characters';
            }
            if (pattern.test(value)) {
                return "Can't start with a number or have non-printable characters";
            }
            break;
        }
        case 'email': {
            const sanitizedEmail = removeZeroWidthChars(value);
            if (!isEmpty(sanitizedEmail) && !isEmail(sanitizedEmail)) {
                return 'Invalid email address';
            }
            break;
        }
        case 'phone': {
            const sanitizedPhone = removeZeroWidthChars(value);
            if (isEmpty(sanitizedPhone)) {
                return 'Phone is required';
            }
            if (!isValidPhone(sanitizedPhone)) {
                return 'Invalid phone number';
            }
            break;
        }
        case 'addressLine': {
            if (isEmpty(value)) {
                return 'Address is required';
            }
            break;
        }
        case 'city': {
            if (isEmpty(value)) {
                return 'City / Town is required';
            }
            break;
        }
        case 'countryCode': {
            if (isEmpty(value)) {
                return 'Country is required';
            }
            break;
        }
        case 'region': {
            if (isEmpty(value)) {
                return 'State / Province / Region  is required';
            }
            break;
        }
        default:
            return undefined;
    }
    return undefined;
};
export const validateFormFieldOnChange = (fieldName, value) => {
    switch (fieldName) {
        case 'name': {
            const pattern = /^[0-9]|[\u0007\u0008\u0009\u000A\u000B\u000C\u000D]/;
            if (value && value.length > 100) {
                return 'Maximum 100 characters';
            }
            if (pattern.test(value)) {
                return "Can't start with a number or have non-printable characters";
            }
            break;
        }
        default:
            return undefined;
    }
};
export const buildTimezoneOptions = () => {
    return moment.tz.names().map((item) => ({ value: item, label: item }));
};
